
app.service('metaData',function(modal, editor, fck){
	let id, urlPath, description, adminMode;

	function setContent(){
		$('#meta-data-content').html(description);
	}
	function save(){
		app.fckUpdate();
		description = $('#meta-data-description').val();
		const $modal = $('#meta-data');
		$modal.addClass('loading');
		$.ajax({
			url: '/cons/viewMetadata-json.ucm',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify({
				urlPath: urlPath,
				description: description,
				id: id || undefined
			}),
			type: 'POST',
			success: function(result){
				$modal.removeClass('loading');
				if(result?.success){
					id = result.viewMetadata.id;
					urlPath = result.viewMetadata.urlPath;
					description = result.viewMetadata.description;
					setContent();
					$('#meta-data-content, #meta-data-edit').prop('hidden', false);
					$('#meta-data-editor, #meta-data-save').prop('hidden', true);
						
				}else{
					alert('jest błąd: ' + result?.error);
				}
			}, error: function(){
				$modal.removeClass('loading');
			}
		});
	}
	function edit(){
		$('#meta-data-content, #meta-data-edit').prop('hidden', true);
		$('#meta-data-editor, #meta-data-save').prop('hidden', false);
		fck.init($('#meta-data-editor'));
	}
	function open(){
		let html = '<div id="meta-data-content"></div>';
		if(adminMode){
			html = '<div id="meta-data-content"></div><button type="button" id="meta-data-edit">Edytuj</button><div id="meta-data-editor" hidden><textarea class="wysiwyg-hidden meta-data-class-id" name="_meta-data-description" data-name="meta-data-description" data-class-id="meta-data-class-id" hidden id="meta-data-textarea">'+description+'</textarea></div><button type="button" id="meta-data-save" hidden>Zapisz</button>';
		}
		modal.generate({
			id: 'meta-data',
			title: 'Meta dane',
			header: 'Opis widoku',
			content: html,
			callbackOpen: function(){
				setContent();
				$('#meta-data-edit').on('click', function(){
					edit();
				});
				$('#meta-data-save').on('click', function(){
					save();
				});
				if(description.length === 0 && adminMode){
					edit();
				}
			}
		});
	}
	function init(){
		description = $('#meta-data-description').html();
		adminMode = $('#meta-data-id').length > 0;
		id = $('#meta-data-id').val();
		urlPath = $('#meta-data-url').val();
		$('#meta-data').remove();

		$('body').on('click','.js-open-meta-data',function(){
			open();
			
		});
		$('body').on('click','.js-edit-meta-data',function(){
			open();
			
		});
	}
	return {
		init
	}
});
